<template>

	<div class="services__bg">

		<video ref="videoRef" autoplay muted>

			<source src="../assets/video/servicesbanner.webm" type="video/webm" />
			 Your browser does not support the video tag.
		</video>

	</div>

</template>

<script>
	import video from "../assets/video/servicesbanner.webm";
	export default {
		// mounted() {
		// 	this.$refs.videoRef.src = video;
		// 	this.$refs.videoRef.play();
		// },

		data() {
			return {};
		},
		mounted() {},
		methods: {},
	};
</script>

<style lang="scss" scoped>
	@import "./ServicesBackgroundBanner.scss";
</style>
